import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useEnquiry } from '../../contexts/EnquiryContext';
import { solutions } from '../../data/solutions';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';
export function Solutions() {
  const {
    setUseCase
  } = useEnquiry();
  const [flagship, ...others] = solutions;
  return <section id="solutions" aria-labelledby="solutions-title" className="bg-afb-light" data-id="element-481" data-mp="34dguvlw89yly">
      <div className="mx-auto max-w-page px-5 py-20 lg:px-8 lg:py-28" data-id="element-482" data-mp="394yzcjxgmhbo">
        <Reveal data-id="element-483" data-mp="3969yg6fyn0wg">
          <SectionHeader id="solutions-title" title="Three systems, one way of working" intro="Start with the All-in-One, add storage to the generators you already have, or build at utility scale." data-id="element-484" data-mp="2vdanmhr4huv8" />
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-2 lg:grid-rows-2" data-id="element-485" data-mp="2lgxvhob87p2l">
          <Reveal className="lg:row-span-2" data-id="element-486" data-mp="2qcmo17otw5pe">
            <article className="flex h-full flex-col overflow-hidden rounded-card border border-afb-line bg-white" data-id="element-487" data-mp="1g8d2bp24dtki">
              <div className="relative" data-id="element-488" data-mp="1b9tetk7vo9q1">
                <img src={flagship.image} alt={flagship.imageAlt} className="aspect-[16/10] w-full object-cover" data-id="element-489" data-mp="1b8s117zh994m" />
                <span className="absolute left-4 top-4 rounded-md bg-afb-ink px-2.5 py-1 text-xs font-semibold text-white" data-id="element-490" data-mp="1p6yt27hqwewd">
                  Flagship
                </span>
                <span className="absolute right-3 top-4 rounded-md bg-black/60 px-2 py-1 text-[11px] text-white/85" data-id="element-491" data-mp="wl72lrdjry31">
                  Illustrative render
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-8" data-id="element-492" data-mp="16ayz4r57j1a5">
                <h3 className="font-sora text-2xl font-semibold tracking-[-0.01em] md:text-[1.75rem]" data-id="element-493" data-mp="11jqkngp0spq4">{flagship.name}</h3>
                <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-afb-ink/80" data-id="element-494" data-mp="dsuoy8hg1adl">{flagship.outcome}</p>
                <div className="mt-auto pt-8" data-id="element-495" data-mp="8u1n5dbir7t9">
                  <Button href={flagship.cta.href} variant="ink" data-id="element-496" data-mp="28x2htgqijnnp">
                    {flagship.cta.label}
                    <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-497" data-mp="2dvvux81w1cnc" />
                  </Button>
                </div>
              </div>
            </article>
          </Reveal>

          {others.map((solution, index) => <Reveal key={solution.id} delay={(index + 1) * 60} data-id="element-498" data-mp="2nkx8ysovhjyo" data-mpi={index}>
              <article className="grid h-full overflow-hidden rounded-card border border-afb-line bg-white sm:grid-cols-[0.9fr_1.1fr]" data-id="element-499" data-mp="1py6qqe9ybpe3">
                <div className="relative" data-id="element-500" data-mp="1uycidug81bw6">
                  <img src={solution.image} alt={solution.imageAlt} className="aspect-[16/10] h-full w-full object-cover sm:aspect-auto" data-id="element-501" data-mp="1uz4fj9pgvhok" />
                  <span className="absolute left-3 top-3 rounded-md bg-black/60 px-2 py-1 text-[11px] text-white/85" data-id="element-502" data-mp="3bbta4gf7xril">
                    Illustrative render
                  </span>
                </div>
                <div className="flex flex-col p-6" data-id="element-503" data-mp="13pje7uogq5i3">
                  <h3 className="font-sora text-xl font-semibold tracking-[-0.01em]" data-id="element-504" data-mp="13p9kbw0are74">{solution.name}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-afb-ink/80" data-id="element-505" data-mp="zozh2r3w31vy">{solution.outcome}</p>
                  <a href={solution.cta.href} onClick={() => solution.id === 'hybrid' && setUseCase('remote')} className="mt-auto inline-flex items-center gap-1.5 pt-6 text-[15px] font-semibold text-afb-teal underline-offset-4 hover:underline" data-id="element-506" data-mp="uvd3mwpwitz3">
                    {solution.cta.label}
                    <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-507" data-mp="bzmyx1ql3jhi" />
                  </a>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}